/**
 * Reads a picked file's natural dimensions, so a stored image carries truthful width/height.
 *
 * Zeroes are a legitimate answer, not a failure: a decode error shouldn't block saving the file, and an
 * SVG saved with only a viewBox — how most vendor logos ship — has an aspect ratio but no intrinsic
 * size. Callers whose images pass through a server-side re-host get corrected dimensions from the bytes
 * actually stored.
 */
export async function readImageDimensions(file: File): Promise<{ width: number; height: number }> {
    const url = URL.createObjectURL(file);
    try {
        return await new Promise((resolve) => {
            const img = new Image();
            img.onload = () => resolve({ width: img.naturalWidth, height: img.naturalHeight });
            img.onerror = () => resolve({ width: 0, height: 0 });
            img.src = url;
        });
    } finally {
        URL.revokeObjectURL(url);
    }
}
